<!-- Divider -->
<div
    class="cipafacil-horizontal-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
